import { formatCurrency } from "../../../../../formatters";
import { BrandMonthlyRow } from "../../../../../Brands/brandsApiMapping";
import MobileBarChart from "../../../../MobileBarChart";

interface BrandsIncomeChartProps {
  rows: BrandMonthlyRow[];
  periodLabel: string;
}

// Mobile's replacement for the desktop BrandsIncomeChart.tsx - same data/
// colors, via MobileBarChart (static value labels) instead of the desktop's
// hover-tooltip pattern (see MobileBarChart.tsx). Still fed by the Monthly
// query; only the label now reflects the selected Month/Year.
export default function BrandsIncomeChart({ rows, periodLabel }: BrandsIncomeChartProps) {
  return (
    <MobileBarChart
      title={`Total income by brand — ${periodLabel}`}
      data={rows.map((row) => ({ label: row.brand.replace(" Optifund", ""), value: row.income }))}
      color="#8E24AA"
      barLabelFormatter={formatCurrency}
    />
  );
}
